// extracted by mini-css-extract-plugin
module.exports = {"cls1":"index-SubHeading-module--cls1--2j2Mz","cls2":"index-SubHeading-module--cls2--1f2h4 index-SubHeading-module--cls1--2j2Mz lead"};